const ProjectReadinessSchema = {
  validation: {
    minProjectGoalLength: 10,
    maxProjectGoalLength: 1000,
  },
  output: {
    readinessLevels: ["urgent", "ready", "planning", "exploring", "unclear"],
    confidenceLevels: ["high", "medium", "low"],
  },
};

export default ProjectReadinessSchema;
